module.exports = __webpack_public_path__ + "static/map1-809037f069fe8cc67077149fc3575a4f.png";